import { GetServerSideProps } from "next";
import ProductDetails from "@/components/productDetails";

interface Product {
  name: string;
  question: string;
  answer: string;
  details: string[];
  title: number;
  image: string;
}

interface ProductPageProps {
  product: Product | null;
}

export default function ProductPage({ product }: ProductPageProps) {
  return <ProductDetails product={product} />;
}

export const getServerSideProps: GetServerSideProps<ProductPageProps> = async (context) => {
  const faqs: Product[] = [
    {
      name: "Mercedes-S",
      question: "Mercedes-Class S",
      answer:
        "La Mercedes-Class S incarne le luxe, la performance et l’innovation. Berline prestigieuse, elle offre un confort inégalé, une technologie de pointe et une conduite silencieuse et puissante. Idéale pour les amateurs d’élégance et de raffinement sans compromis.",
      details: [
        "Système multimédia MBUX avec écran tactile et commande vocale intelligente",
        "Pack de sécurité avancé avec assistance au freinage, détection des angles morts et conduite semi-autonome",
        "Climatisation automatique multi-zones avec purification de l’air",
        "Caméra 360° et assistant de stationnement actif",
        "Accès mains libres et démarrage sans clé",
        "Sièges avant et arrière chauffants, ventilés et massants",
        "Confort de conduite exceptionnel avec suspension pneumatique adaptative"
      ],
      title: 90,
      image: "/images/class_ms1.webp",
    },
    {
      name: "Mercedes",
      question: "Mercedes Classe V",
      answer:
        "La Mercedes Classe V est un monospace premium qui associe design sophistiqué, espace généreux et technologies avancées.",
      details: [
        "Design & Confort : Extérieur raffiné, intérieur modulable (jusqu’à 8 places), sièges en cuir, toit panoramique",
        "Performance : Motorisations diesel, boîte auto 9G-TRONIC, suspensions optimisées",
        "Technologie & Sécurité : MBUX, écran tactile, régulateur adaptatif, caméra 360°, freinage d’urgence",
      ],
      title: 90,
      image: "/images/faq2.jpg",
    },
    {
      name: "Tesla",
      question: "Tesla Model Y",
      answer:
        "La Tesla Model Y est un SUV électrique polyvalent qui allie performance, autonomie et technologie de pointe.",
      details: [
        "Technologie & Confort : Écran 15″, toit panoramique, sièges chauffants, audio premium",
        "Performance : Transmission intégrale, Autopilot, 0-100 km/h en 3,7s (Performance)",
        "Autonomie & Recharge : Jusqu’à 533 km, Superchargeurs Tesla, recharge rapide",
        "Connectivité : Appli mobile, mises à jour OTA, navigation intelligente",
        "Sécurité : Caméras 360°, Mode Sentinelle, freinage d’urgence",
      ],
      title: 60,
      image: "/images/faq3.jpg",
    },
  ];

  const productName = (context.params?.productName as string)?.toLowerCase();
  const product = faqs.find((faq) => faq.name.toLowerCase() === productName) || null;

  return { props: { product } };
};
